"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Label = _interopRequireDefault(require("./Label"));

var _chevron = _interopRequireDefault(require("../../assets/images/chevron.svg"));

var _InputContainer = _interopRequireDefault(require("../../Form/Input/InputContainer"));

var _Constant = require("../Constant");

var _Input = require("./Input");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  ", "\n  ", "\n  margin-top: 8px;\n  text-rendering: auto; // Override for Safari so it does not crash the browser on 13.0.1\n  border: 1px solid ", ";\n  background: url(", ") center right 5px no-repeat;\n  background-position: 95%;\n  select ::-ms-expand {\n    display: none;\n  } // for IE\n\n  &:hover:not([disabled]) {\n    border-color: ", ";\n  }\n\n  &:focus {\n    outline: 2px solid ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Select = _styledComponents.default.select.attrs(function (_ref) {
  var errorText = _ref.errorText;
  return {
    'data-error': errorText && errorText.length > 0
  };
})(_templateObject(), _Input.inputStyles, _Input.dashboardStyles, function (props) {
  return props['data-error'] ? _Constant.Color.LIPSTICK_RED : _Constant.Color.GREY_4;
}, _chevron.default, _Constant.Color.FOCUS_B, _Constant.Color.FOCUS_B);

Select.propTypes = {
  errorText: _propTypes.default.string
};

var DropdownSelect = function DropdownSelect(_ref2) {
  var id = _ref2.id,
      isHiddenLabel = _ref2.isHiddenLabel,
      label = _ref2.label,
      value = _ref2.value,
      errorText = _ref2.errorText,
      onChange = _ref2.onChange,
      children = _ref2.children,
      otherProps = (0, _objectWithoutProperties2.default)(_ref2, ["id", "isHiddenLabel", "label", "value", "errorText", "onChange", "children"]);

  var inputProps = _objectSpread(_objectSpread({}, otherProps), {}, {
    id: id,
    value: value,
    onChange: onChange,
    errorText: errorText,
    'aria-invalid': errorText ? 'true' : null
  });

  return /*#__PURE__*/_react.default.createElement(_InputContainer.default, null, /*#__PURE__*/_react.default.createElement(_Label.default, {
    htmlFor: id,
    value: value,
    errorText: errorText,
    isVisuallyHidden: isHiddenLabel
  }, label), /*#__PURE__*/_react.default.createElement(Select, inputProps, children));
};

DropdownSelect.propTypes = {
  /** The id for the input */
  id: _propTypes.default.string.isRequired,

  /** The label for the input */
  label: _propTypes.default.string.isRequired,

  /** Value that controls the  */
  value: _propTypes.default.string.isRequired,

  /** Used for validation */
  errorText: _propTypes.default.string,

  /** Function used to update the value prop */
  onChange: _propTypes.default.func.isRequired,

  /** The <option />(s) for the dropdown */
  children: _propTypes.default.node.isRequired,

  /** Ideally, label text is always visible.
   * If necessary, this prop will hide label text from sighted users while still making it available to assistive technology.
   * It will not hide error text.
   */
  isHiddenLabel: _propTypes.default.bool
  /** The label for the input */

};
DropdownSelect.defaultProps = {
  errorText: '',
  isHiddenLabel: false
};
var _default = DropdownSelect;
exports.default = _default;